import { get } from 'lodash-es';
import { PAGE_TYPE } from '../constants/logger';

/**
 * @description Build message for Sentry
 * @param {object} payload
 * @param {Error | string} payload.error - error message or error object
 * @param {string} payload.sourceName - source where the error occurred
 * @param {string} payload.page - should be one of { PAGE_TYPE } from '../../../constants/logger'
 */
const buildLoggerMessage = ({ error, page, sourceName }) => {
  const message =
    typeof error === 'string'
      ? error
      : get(error, 'message', JSON.stringify(error));

  return `[${page}][${sourceName}] ${message}`;
};

/**
 * @description Use logger in shop for SCM
 * @param {object} payload
 * @param {Error | string} payload.error - error message or error object
 * @param {string} payload.sourceName - source where the error occurred
 * @param {string} payload.page - { PAGE_TYPE } from '../../../constants/logger'
 * @param {object} payload.extraInfo - extra information to be logged
 * @param {function} scopeCallback - callback function to be called with the scope
 * @param {string} [payload.debugMessage] - debug message to be logged
 */
const onLogError = (payload, scopeCallback) => {
  const { sourceName, page, error, extraInfo, debugMessage } = payload;
  const loggerMessage = buildLoggerMessage({ error, page, sourceName });

  if (process.env.NODE_ENV === 'development') {
    if (!Object.values(PAGE_TYPE).includes(page)) {
      console.warn(`[Logger] Invalid page type: "${page}".`);
    }

    console.error(debugMessage || loggerMessage, error);
  }

  if (typeof window.Sentry !== 'undefined') {
    window.Sentry.withScope((scope) => {
      scope.setLevel(window.Sentry.Severity.Error);

      scope.setExtra(
        'extraInfo',
        JSON.stringify({
          error,
          ...(extraInfo && { extraInfo }),
        }),
      );

      if (scopeCallback) {
        scopeCallback(scope);
      }

      window.Sentry.captureMessage(loggerMessage);
    });
  } else {
    console.error(loggerMessage, payload);
  }
};
export default onLogError;
